// src/pages/Appli/AppliAdmin/VisitorCenter/utils/visitorFormatters.js

const PAGE_LABELS = {
  "/": "Accueil",
  "/tarifs": "Tarifs",

  "/applications":
    "Applications",

  "/contact": "Contact",

  "/demo":
    "Démonstration",

  "/product-monappliclub":
    "MonAppliClub Standard",

  "/product-monappliclub-light":
    "MonAppliClub Light",

  "/product-monappliclub-omnisports":
    "MonAppliClub Omnisports",

  "/product-monappliclub-tournoi":
    "MonAppliTournoi",

  "/product-monapplimairie":
    "MonAppliMairie",

  "/product-judocoachpro":
    "Judo Coach Pro",

  "/product-judopresencepro":
    "Judo Présence Pro",
};

export function safeNumber(value) {
  const number = Number(value);

  return Number.isFinite(number)
    ? number
    : 0;
}

export function formatPageLabel(page) {
  if (!page) {
    return "Page inconnue";
  }

  const cleanPage =
    page.split("?")[0];

  return (
    PAGE_LABELS[cleanPage] ||
    cleanPage
  );
}

export function formatDateTime(value) {
  if (!value) {
    return "—";
  }

  const date = new Date(value);

  if (
    Number.isNaN(
      date.getTime(),
    )
  ) {
    return "—";
  }

  return new Intl.DateTimeFormat(
    "fr-FR",
    {
      dateStyle: "short",
      timeStyle: "short",
    },
  ).format(date);
}

export function formatDateOnly(value) {
  if (!value) {
    return "—";
  }

  const date = new Date(
    `${value}T12:00:00`,
  );

  if (
    Number.isNaN(
      date.getTime(),
    )
  ) {
    return "—";
  }

  return new Intl.DateTimeFormat(
    "fr-FR",
    {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    },
  ).format(date);
}

export function formatChartDate(value) {
  if (!value) {
    return "";
  }

  const date = new Date(
    `${value}T12:00:00`,
  );

  if (
    Number.isNaN(
      date.getTime(),
    )
  ) {
    return value;
  }

  return new Intl.DateTimeFormat(
    "fr-FR",
    {
      day: "2-digit",
      month: "2-digit",
    },
  ).format(date);
}

export function formatTime(value) {
  if (!value) {
    return "—";
  }

  const date = new Date(value);

  if (
    Number.isNaN(
      date.getTime(),
    )
  ) {
    return "—";
  }

  return new Intl.DateTimeFormat(
    "fr-FR",
    {
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    },
  ).format(date);
}

export function formatRelativeTime(
  value,
) {
  if (!value) {
    return "activité inconnue";
  }

  const date = new Date(value);

  if (
    Number.isNaN(
      date.getTime(),
    )
  ) {
    return "activité inconnue";
  }

  const seconds = Math.max(
    0,
    Math.floor(
      (
        Date.now() -
        date.getTime()
      ) / 1000,
    ),
  );

  if (seconds < 10) {
    return "à l’instant";
  }

  if (seconds < 60) {
    return `il y a ${seconds} s`;
  }

  const minutes =
    Math.floor(seconds / 60);

  if (minutes < 60) {
    return `il y a ${minutes} min`;
  }

  const hours =
    Math.floor(minutes / 60);

  if (hours < 24) {
    return `il y a ${hours} h`;
  }

  return formatDateTime(value);
}

export function formatDuration(
  secondsValue,
) {
  const seconds =
    Math.max(
      0,
      Math.round(
        safeNumber(
          secondsValue,
        ),
      ),
    );

  if (seconds < 60) {
    return `${seconds} s`;
  }

  const minutes =
    Math.floor(seconds / 60);

  const remainingSeconds =
    seconds % 60;

  if (minutes < 60) {
    if (
      remainingSeconds === 0
    ) {
      return `${minutes} min`;
    }

    return `${minutes} min ${remainingSeconds} s`;
  }

  const hours =
    Math.floor(minutes / 60);

  const remainingMinutes =
    minutes % 60;

  if (
    remainingMinutes === 0
  ) {
    return `${hours} h`;
  }

  return `${hours} h ${remainingMinutes} min`;
}

export function formatCompactNumber(
  value,
) {
  const number =
    safeNumber(value);

  return new Intl.NumberFormat(
    "fr-FR",
    {
      notation:
        number >= 10000
          ? "compact"
          : "standard",

      maximumFractionDigits: 1,
    },
  ).format(number);
}

export function formatPercentage(
  value,
  decimals = 1,
) {
  return `${safeNumber(
    value,
  ).toLocaleString("fr-FR", {
    minimumFractionDigits: 0,
    maximumFractionDigits:
      decimals,
  })} %`;
}

export function formatLocation(
  visitor,
) {
  const values = [
    visitor?.city_name,
    visitor?.region_name,
    visitor?.country_name,
  ].filter(Boolean);

  return values.length
    ? values.join(", ")
    : "Localisation inconnue";
}

export function formatTrafficSource(
  visitor,
) {
  const source =
    visitor?.source || "direct";

  const medium =
    visitor?.medium;

  if (
    !medium ||
    medium === "none"
  ) {
    return source;
  }

  return `${source} · ${medium}`;
}

export function formatDevice(
  visitor,
) {
  const values = [
    visitor?.device_type,
    visitor?.browser_name,
    visitor?.os_name,
  ].filter(Boolean);

  return values.length
    ? values.join(" · ")
    : "Appareil inconnu";
}

export function getVisitorName(
  visitor,
) {
  const conversation =
    visitor?.conversations?.find(
      (item) =>
        item.visitor_name,
    ) || null;

  return (
    conversation?.visitor_name ||
    visitor?.city_name ||
    `Visiteur #${
      visitor?.id || "—"
    }`
  );
}

export function isValidCoordinate(
  value,
) {
  return Number.isFinite(
    Number(value),
  );
}